import { Code } from 'lucide-react';

import { CodeEditor } from '@/components/ui/CodeEditor';

import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'code',
  renderInput: ({ field, value, onChange }) => {
    const lang = (field as { code_language?: string }).code_language ?? 'javascript';
    return (
      <CodeEditor
        value={(value as string) || ''}
        onChange={(code) => onChange(code || null)}
        language={lang}
        placeholder={`Wprowadź kod (${lang})…`}
      />
    );
  },
  renderCell: (_field, value) => {
    if (!value) return '—';
    const firstLine = (String(value).split('\n')[0] ?? '').slice(0, 60);
    const hasMore = String(value).split('\n').length > 1;
    return (
      <div className="flex items-center gap-2">
        <Code className="h-3.5 w-3.5 flex-shrink-0 text-text-muted" />
        <code className="rounded bg-bg-secondary px-2 py-0.5 font-mono text-xs text-text-primary">
          {firstLine}
          {firstLine.length >= 60 || hasMore ? '…' : ''}
        </code>
      </div>
    );
  },
  validate: (value, field) => {
    if (!value) return field.isRequired ? 'Pole wymagane' : null;
    const rules = (field.validationRules ?? {}) as Record<string, unknown>;
    const code = String(value);
    if (rules['minLength'] && code.length < Number(rules['minLength']))
      return `Minimum ${rules['minLength']} znaków`;
    if (rules['maxLength'] && code.length > Number(rules['maxLength']))
      return `Maksimum ${rules['maxLength']} znaków`;
    return null;
  },
  defaultValue: '',
});
